import { BannerConfig } from '@/src/api/payg/types';
import { Stack } from '@ovotech/element-v5';
import { Notification } from '@ovotech/nebula';
import React from 'react';
import { StyledHeading, StyledP } from './styles';
import { getExtraButtons, getNormalisedText } from './utils';

export const RemoteAlerts = ({
  type,
  heading,
  shortMessage,
  moreActions,
}: BannerConfig) => (
  <Notification id={heading} variant={type}>
    <Stack spaceBetween={3}>
      <StyledHeading>{heading}</StyledHeading>
      <StyledP>{getNormalisedText(shortMessage)}</StyledP>
      {moreActions.length > 0 && (
        <Stack spaceBetween={4} orientation="horizontal">
          {getExtraButtons(moreActions)}
        </Stack>
      )}
    </Stack>
  </Notification>
);
